import { axiosInstance } from "./api.service";
import authHeader from "./auth.header";
import toast from "react-hot-toast";

const getFile = async (filename) => {
	try {
		const res = await axiosInstance.get(`/files/file/${filename}`, {
			headers: authHeader(),
		});
		if (res.data.success === true) {
			return res.data;
		}
	} catch (err) {
		if (err.response && err.response.status === 401) {
			toast.error(err.msg);
		}
		toast.error(err.response.data.msg);
	}
};

const getImageFile = async (filename) => {
	try {
		const res = await axiosInstance.get(`/files/image/${filename}`, {
			headers: authHeader(),
		});
		if (res.data.success === true) {
			return res.data;
		}
	} catch (err) {
	if (err.response && err.response.status === 401) {
			toast.error(err.msg);
		}
		toast.error(err.response.data.msg);
	}
};

const deleteFile = async (filename) => {
	try {
		const res = await axiosInstance.delete(`/files/file/${filename}`, {
			headers: authHeader(),
		});
		if (res.data.success === true) {
			return toast.success(res.data.msg);
		}

		return toast.error(res.data.msg);
	} catch (err) {
	if (err.response && err.response.status === 401) {
			toast.error(err.msg);
		}
		toast.error(err.response.data.msg);
	}
};

const uploadAvatar = async (file) => {
	try {
		const res = await axiosInstance.post("/avatar", file, {
			headers: authHeader(),
		});
		if (res.data.success === true) {
			return res.data;
		}
	} catch (err) {
	if (err.response && err.response.status === 401) {
			toast.error(err.msg);
		}
		toast.error(err.response.data.msg);
	}
};

const FileService = {
	getFile,
	getImageFile,
	deleteFile,
	uploadAvatar,
};

export default FileService; 
